import React from 'react'

const CustomButton = ({
    loading = false,
    textLoad = 'Procesando',
    onClick,
    className = '',
    children,
    isDisabled = false,
    variant = 'primary', // primary | secondary | danger
    ...props
}) => {

    const variants = {
        primary: 'bg-cs-primary text-white',
        secondary: 'bg-cs-surface-alt text-cs-dark',
        danger: 'bg-cs-danger text-white',
    }

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={loading || isDisabled}
            className={`
        w-full
        min-h-touch
        flex items-center justify-center
        rounded-xl
        text-base
        font-medium
        transition
        ${variants[variant]}
        disabled:opacity-50
        disabled:cursor-not-allowed
        ${className}
      `}
            {...props}
        >
            {loading ? (
                <>
                    <svg
                        className="animate-spin h-5 w-5 mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        />
                    </svg>
                    <span>{textLoad}…</span>
                </>
            ) : (
                <span>{children}</span>
            )}
        </button>
    )
}

export default CustomButton